import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const MilkIcon = ({
  innerColor = '#fefefe',
  outerColor = '#804330',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_125"
        data-name="Grupo 125"
        transform="translate(-51.5 -2094)"
      >
        <g
          id="Rectángulo_14"
          data-name="Rectángulo 14"
          transform="translate(51.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="milk-bottle" transform="translate(61.546 2099.904)">
          <path
            id="Trazado_9088"
            data-name="Trazado 9088"
            d="M134.748,5.031l-1.467-2.907v-.67h.081a.242.242,0,0,0,.242-.242V.242A.242.242,0,0,0,133.362,0h-3.5a.242.242,0,0,0-.242.242v.97a.242.242,0,0,0,.242.242h.081v.67l-1.467,2.907a3.455,3.455,0,0,0-.317,1.333V14.3a.89.89,0,0,0,.889.889h5.129a.89.89,0,0,0,.889-.889V6.364a3.456,3.456,0,0,0-.317-1.333ZM130.1.485h3.015V.97H130.1Zm.3,1.806a.242.242,0,0,0,.026-.109V1.455H132.8v.727a.242.242,0,0,0,.026.109l.923,1.828a1.34,1.34,0,0,0-.4.227.714.714,0,0,1-.959,0,1.193,1.193,0,0,0-1.54,0,.713.713,0,0,1-.959,0,1.339,1.339,0,0,0-.4-.227l.923-1.828ZM134.58,14.3a.4.4,0,0,1-.4.4h-5.129a.4.4,0,0,1-.4-.4V6.364a2.987,2.987,0,0,1,.265-1.114l.347-.688a.763.763,0,0,1,.337.173,1.193,1.193,0,0,0,1.54,0,.714.714,0,0,1,.959,0,1.193,1.193,0,0,0,1.54,0,.762.762,0,0,1,.337-.173l.347.688a2.987,2.987,0,0,1,.265,1.114Z"
            transform="translate(-128.158 0)"
          />
          <path
            id="Trazado_9089"
            data-name="Trazado 9089"
            d="M158.4,395a.242.242,0,0,0-.242.242v.97a.242.242,0,1,0,.485,0v-.97A.242.242,0,0,0,158.4,395Z"
            transform="translate(-157.189 -382.232)"
          />
          <path
            id="Trazado_9090"
            data-name="Trazado 9090"
            d="M158.7,165.062a.242.242,0,0,0-.326.107,2.576,2.576,0,0,0-.213.9v5.677a.242.242,0,0,0,.485,0v-5.677a2.143,2.143,0,0,1,.161-.677A.242.242,0,0,0,158.7,165.062Z"
            transform="translate(-157.189 -159.701)"
          />
          <path
            id="Trazado_9091"
            data-name="Trazado 9091"
            d="M213.6,60.485h.914a.242.242,0,0,0,0-.485H213.6a.242.242,0,1,0,0,.485Z"
            transform="translate(-210.606 -58.06)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default MilkIcon;
